import React, { useEffect, useRef, useState } from "react";
import ContentList from "../globals/organize/ContentList";
import PageList from "../globals/organize/PageList";

export default function OrganizePanel(props) {

    const containerRef = useRef();
    const { updateContent = () => { }, selected = "", setSelected = () => { }, menus = [], setMenus = () => { }, setToOpenPage = () => { }, page = { id: 0 }, setPage = () => { }, content = [], setContent = () => { } } = props;
    const [open, setOpen] = useState(false)


    const onSetOpen = (_e) => {
        if (_e && containerRef.current) {
            containerRef.current.parentNode.scrollTo({
                top: 0,
                behavior: 'smooth' // You can use 'auto' for instant scrolling
            });
        }
        setOpen(_e)
    }

    return (
        <>
            <div ref={containerRef} className={(open) ? "float-flex organise-opened" : "float-flex organise-closed"}>
                <div style={{ "width": "300px" }}>
                    <PageList selected={selected} setSelected={setSelected} setOpen={onSetOpen} menus={menus} setMenus={setMenus} setToOpenPage={setToOpenPage} page={page} setPage={setPage} content={content} setContent={setContent} />
                </div>
                <div style={{ "width": "300px" }}>
                    <ContentList updateContent={updateContent} selected={selected} setSelected={setSelected} content={content} menus={menus} page={page} setOpen={onSetOpen} />
                </div>
            </div>
        </>
    )

}